import React, { useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';

import useGlobal from '../../../store';
import RetencionesMasivasTicketsList from './list/RetencionesMasivasTicketsList';
import RetencionesMasivasTicketsSearch from './components/RetencionesMasivasTicketsSearch';
import RetencionesMasivasTicketsActions from './components/RetencionesMasivasTicketsActions';
import RetencionesMasivasTicketsFilters from './components/RetencionesMasivasTicketsFilters';
import RetencionesMasivasTicketsItemActions from './components/RetencionesMasivasTicketsItemActions';

const mapState = (store) => {
  return store.modulo.retenciones_masivas.tickets.list;
};

const mapActions = (actions) => {
  return actions.modulo.retenciones_masivas.tickets.list;
};

const RetencionesMasivasTickets = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);

  useEffect(() => {
    window.setAppTitle('Tickets');
  }, []);

  const handleOnRowSelectionChange = ({ selectedRowKeys, selectedRows }) => {
    actions.setSelectedRows({
      selectedRowKeys,
      selectedRows,
    });
  };

  const handleOnRowClick = (data) => {
    props.history.replace({
      pathname: `/modulos/retenciones-masivas/tickets/${data.id}/info`,
      state: {
        data: { ...data },
      },
    });
  };

  const handleOnDateChange = (event) => {
    paginate(event);
  };

  const handleOnKeywordChange = (event) => {
    paginate(event);
  };

  const paginate = (event) => {
    actions.paginate({
      filters: { ...event },
      pagination: { page: 1 },
    });
  };

  const { selectedRowKeys, selectedRows, filters = {} } = state;
  const { search, from, to } = filters;

  return (
    <>
      <Row>
        <Col
          sm="auto"
          md="8"
          className="mb-2"
        >
          {selectedRowKeys.length > 0 && (
            <RetencionesMasivasTicketsItemActions
              selectedRowKeys={selectedRowKeys}
              selectedRows={selectedRows}
              alignRight={false}
            />
          )}

          {selectedRowKeys.length === 0 && (
            <RetencionesMasivasTicketsSearch
              from={from}
              to={to}
              search={search}
              onDateChange={handleOnDateChange}
              onKeywordChange={handleOnKeywordChange}
            />
          )}
        </Col>
        <Col
          sm="auto"
          md="4"
          className="text-right pb-2"
        >
          {selectedRowKeys.length === 0 && (
            <RetencionesMasivasTicketsActions
              from={from}
              to={to}
              selectedRowKeys={selectedRowKeys}
              selectedRows={selectedRows}
              alignRight={false}
            />
          )}
        </Col>
      </Row>

      <RetencionesMasivasTicketsFilters />

      {Guardian.allows('retencion.masiva.listar.tickets') && (
        <RetencionesMasivasTicketsList
          onRowClick={handleOnRowClick}
          selectedRowKeys={selectedRowKeys}
          selectedRows={selectedRows}
          onRowSelectionChange={handleOnRowSelectionChange}
        />
      )}
    </>
  );
};

export default RetencionesMasivasTickets;
